import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Img from "react-cool-img";

import Linkify from 'react-linkify';
import { useTranslation } from 'react-i18next/hooks';

import { useStore } from '../../../../hook-store/store';
// import { getDateTime } from '../../../../../util/timeFormat';
// import { scrollToTextListRefItem } from '../../../../../util/group/group-text-list';

// import { marks } from '../../../../images/marks';
import classes from './GroupTalkTextItem.module.css';

import SampleImage from "../../../Image/person-icon-50.jpg";

const GroupTextNameIcons = (props) => {
  // console.log('GroupTalkTextItem-props', props);
  const { 
    lsNameDataList,
    textList, 
    size, 
    limit,
   } = props;

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  // const {
  //   selectedGroupData,
  //   groupTextItemRef,
  // } = store.groupStore;
  // console.log('store in GroupTalkTextItem', store);
  

  let groupTextNameIconsBody;

  const iSize = `${size}rem`;

  groupTextNameIconsBody = (
    <span className={classes.groupTextItemReplyNameIcons}>
      <ul>
        {textList.map((text, index) => {
          let nameData;

          if (lsNameDataList && JSON.parse(lsNameDataList).length > 0) {
            nameData = JSON.parse(lsNameDataList).find(ele => {
              return ele.userId === text.fromUserId;
            });
          }

          if (index < limit) {
            if (nameData && nameData.imageUrl) {
              return (
                <img 
                  style={{width: iSize, height: iSize, objectFit: "cover"}}
                  src={nameData.imageUrl}
                />
              );
            } else {
                return (
                  <img 
                    style={{width: iSize, height: iSize, objectFit: "cover"}}
                    src={SampleImage}
                  />
                );
            }
          } else {
            return null;
          }
        })}
      </ul>
      {textList.length > limit && (
        <span>...</span>
      )}
    </span>     
  );

  return (
    <Fragment>
      {groupTextNameIconsBody}
    </Fragment>
  );
}

export default GroupTextNameIcons;